import axios from 'axios';
import moment from 'moment';

const API_URL = process.env.REACT_APP_API_URL;
const INFLUENCERS_URL = `${API_URL}/api/influencers/`;

export interface FreePlan {
  plan_id: number;
  plan_code: string;
  user_id: number;
  user_email: string;
}

export function generateReport({ since, until, code }) {
  const params = new URLSearchParams();
  if (since) params.set('start_date', moment(since).format('YYYY-MM-DD'));
  if (until) params.set('end_date', moment(until).format('YYYY-MM-DD'));
  if (code) params.set('code', code);

  return axios.get(`${INFLUENCERS_URL}stats/?${params.toString()}`);
}

export function getFreePlans() {
  return axios.get<FreePlan[]>(`${INFLUENCERS_URL}free-plans/`);
}
